export default __webpack_public_path__ + "static/media/4077.b859434d.png";